import React from "react";

const Header = () => {
  return (
    <header>
      <div className="title">Wordle</div>
    </header>
  );
};

export default Header;
